
import styled from 'styled-components'

export const ManageUsersLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
  padding-left: 15px;
`

export const ManageUsersSeparator = styled.div`
  display: inline-block;
  vertical-align: middle; 
  margin: 4px 16px 0 16px;
  width: 1px;
  height: 24px;
  background: rgba(32, 32, 32, 0.1);
`

export const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  background: #E9E9E9;
  height: 32px;
  border-radius: 50%;
  > p {
    position: absolute;
    width: 100%;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: white;
    padding-left: 9px;
    margin-top: 10px;
  }
`

export const ManageUserDropdownItem = styled.div`
  height: 32px;
  display: flex; 
  width: 100%;
  justify-content: space-between;
`

export const ManageUserWrapper = styled.div`
  display: flex;
`

export const ManageUserAvatar = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
`

export const ManageUserName = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 16px;
`

export const UserName = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
`

export const UserEmail = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.5);
`
